import { service } from '@ember/service';
import Component from '@glimmer/component';

import { t } from 'ember-intl';
import { not, or } from 'ember-truth-helpers';

import Button from 'umg-ember-backend/components/ui/button';
import ContextMenu from 'umg-ember-backend/components/ui/context-menu';

export default class RecordDetailToolbarSecondaryComponent extends Component {
  // Services
  @service abilities;
  @service permission;
  @service recordLocks;
  @service recordStatus;
  @service recordVariants;

  // Getter and setter
  get isLocked() {
    return this.recordLocks.isLocked(this.args.model);
  }

  get isBlockable() {
    const { model, actions } = this.args;

    return actions?.onBlock && this.abilities.can('blockEntity', model);
  }

  get isDeltable() {
    return this.abilities.can('delete', this.args.model);
  }

  get isVariant() {
    return this.recordVariants.isVariant(this.args.model);
  }

  get isBlocked() {
    return this.recordStatus.isBlocked(this.args.model);
  }

  get isDisabled() {
    return this.recordStatus.isDisabled(this.args.model);
  }

  get isResetable() {
    return this.args.actions?.onReset && this.permission.user.get('isAdmin');
  }

  get isUnlockable() {
    const model = this.args.model;

    return this.isLocked && this.abilities.can('unlockEntity', model);
  }

  get isUnpublishable() {
    const { actions, model } = this.args;
    const action = model.isNew ? 'create' : 'update';

    return actions?.onUnpublish && this.abilities.can(action, model);
  }

  // Template
  <template>
    {{#if
      (or this.isDeltable this.isUnlockable this.isBlockable this.isResetable)
    }}
      <ContextMenu>
        <:trigger>
          <Button @style='grey' @icon='more' />
        </:trigger>
        <:content as |content|>
          {{#if this.isDeltable}}
            <content.Item
              @icon='delete'
              @onClick={{@actions.onDeleteRecord}}
              @isDisabled={{this.isDisabled}}
              @label={{if
                this.isVariant
                (t 'record_detail.toolbar.secondary.delete_variant')
                (t 'record_detail.toolbar.secondary.delete')
              }}
            />
          {{/if}}

          {{#if this.isUnpublishable}}
            <content.Item
              @icon='hide'
              @onClick={{@actions.onUnpublish}}
              @label={{t 'record_detail.toolbar.secondary.unpublish'}}
              @isDisabled={{not @model.hasVisiblePublisheMlp}}
            />
          {{/if}}

          {{#if this.isUnlockable}}
            <content.Item
              @icon='force-unlock'
              @onClick={{@actions.onForceUnlock}}
              @label={{t 'record_detail.toolbar.secondary.unlock'}}
            />
          {{/if}}

          {{#if this.isBlockable}}
            <content.Item
              @isDisabled={{this.isLocked}}
              @icon={{if this.isBlocked 'unlock' 'lock'}}
              @onClick={{if this.isBlocked @actions.onUnblock @actions.onBlock}}
              @label={{if
                this.isBlocked
                (t 'record_detail.toolbar.secondary.unblock')
                (t 'record_detail.toolbar.secondary.block')
              }}
            />
          {{/if}}

          {{#if this.isResetable}}
            <content.Item
              @icon='reset'
              @onClick={{@actions.onReset}}
              @isDisabled={{this.isDisabled}}
              @label={{t 'record_detail.toolbar.secondary.reset'}}
            />
          {{/if}}
        </:content>
      </ContextMenu>
    {{/if}}
  </template>
}
